<template>
  <div :class="['elem', center && 'elem--center', span && `elem--span-${span}`]">
    <slot />
  </div>
</template>

<script setup lang="ts">
  import type { BasicCellProps } from './BasicCell.types'

  withDefaults(defineProps<BasicCellProps>(), {
    center: false,
    span: 2,
  })
</script>
